import { EChatBotsMessengers } from '@common/enums/chat-bots.enum';

/**
 * The base a Messenger bot link is *built* from.
 *
 * `m.me` is Meta's legacy shortener and is being retired, so a link generated today has to be a
 * `messenger.com/t/<page>` one (#73155). It is deliberately not the first entry of
 * `chatBotsUrl[messenger]` below: that list is what a *pasted* link is matched against, and `m.me`
 * has to stay accepted there — links already saved in widget data are still valid, and the renderer
 * rewrites those on the fly (`normalizeMessengerShortLink` in websites-builder).
 *
 * Note the `/t` path segment, which is why this can't just be reordered into that list: `m.me/<page>`
 * and `messenger.com/t/<page>` address the same conversation with different shapes.
 */
export const MESSENGER_BOT_LINK_BASE = 'https://messenger.com/t';

export const chatBotsUrl = {
    [EChatBotsMessengers.telegram]: [
        'https://t.me',
        'https://telegram.me',
        'http://t.me',
        'http://telegram.me',
        'https://www.t.me',
        'https://www.telegram.me',
        'http://www.t.me',
        'http://www.telegram.me',
        'tg://',
    ],
    [EChatBotsMessengers.vk]: [
        'https://vk.me',
        'https://vk.com',
        'http://vk.me',
        'http://vk.com',
        'https://www.vk.me',
        'https://www.vk.com',
        'http://www.vk.me',
        'http://www.vk.com',
    ],
    [EChatBotsMessengers.messenger]: [
        'https://m.me',
        'https://messenger.com',
        'https://www.messenger.com',
        'http://m.me',
        'http://messenger.com',
        'http://www.messenger.com',
    ],
    [EChatBotsMessengers.instagram]: [
        'https://instagram.com',
        'http://instagram.com',
        'https://www.instagram.com',
        'http://www.instagram.com',
        'https://ig.me',
        'https://www.ig.me',
    ],
    [EChatBotsMessengers.whatsapp]: [
        'https://wa.pulse.is',
        'https://wa.me',
        'https://web.whatsapp.com',
        'http://wa.me',
        'http://web.whatsapp.com',
        'https://www.wa.me',
        'https://www.web.whatsapp.com',
        'http://www.wa.me',
        'http://www.web.whatsapp.com',
        'https://api.whatsapp.com/send',
        'https://www.api.whatsapp.com/send',
        'whatsapp://',
    ],
    [EChatBotsMessengers.facebook]: [
        'https://facebook.com',
        'https://www.messenger.com',
        'http://facebook.com',
        'http://www.messenger.com',
        'https://www.facebook.com',
        'https://messenger.com',
        'http://www.facebook.com',
        'http://messenger.com',
    ],
    [EChatBotsMessengers.viber]: [
        'https://vb.me',
        'https://chats.viber.com',
        'http://vb.me',
        'http://chats.viber.com',
        'https://www.vb.me',
        'https://www.chats.viber.com',
        'http://www.vb.me',
        'http://www.chats.viber.com',
        'https://viber.click',
        'https://www.viber.click',
        'https://invite.viber.com',
        'https://www.invite.viber.com',
        'viber://',
    ],
    [EChatBotsMessengers.snapchat]: [
        'https://snapchat.com',
        'http://snapchat.com',
        'https://www.snapchat.com',
        'http://www.snapchat.com',
    ],
    [EChatBotsMessengers.skype]: [
        'https://join.skype.com',
        'http://join.skype.com',
        'https://www.join.skype.com',
        'http://www.join.skype.com',
    ],
    [EChatBotsMessengers.ok]: [
        'https://ok.me',
        'https://ok.ru',
        'http://ok.me',
        'http://ok.ru',
        'https://www.ok.me',
        'https://www.ok.ru',
        'http://www.ok.me',
        'http://www.ok.ru',
    ],
    [EChatBotsMessengers.line]: [
        'https://clova.line.me',
        'https://line.me',
        'http://clova.line.me',
        'http://line.me',
        'https://www.clova.line.me',
        'https://www.line.me',
        'http://www.clova.line.me',
        'www.http://line.me',
    ],
    [EChatBotsMessengers.kik]: [
        'https://www.kik.com',
        'https://www.kik.co',
        'http://www.kik.com',
        'http://www.kik.co',
        'https://kik.com',
        'https://kik.co',
        'http://kik.com',
        'http://kik.co',
    ],
    [EChatBotsMessengers.tiktok]: ['https://tiktok.me'],
};
